import { apiClient } from "@/api/client";
import type { Promo, PromoStatus } from "@/types/domain";

export interface PromoInput {
  code: string;
  title: string;
  detail?: string;
  discountType?: "PERCENT" | "FLAT";
  value: number;
  maxDiscount?: number;
  minFare?: number;
  status?: PromoStatus;
  featured?: boolean;
  startsAt?: string;
  endsAt?: string;
  firstRideOnly?: boolean;
}

/** Talks to admin-service's promo delegate (see admin.controller.ts). */
export const promosApi = {
  /** GET /admin/promos */
  list: () => apiClient.get<Promo[]>("/admin/promos").then((r) => r.data),

  /** POST /admin/promos — ADMIN/OPERATIONS only. */
  create: (payload: PromoInput) => apiClient.post<Promo>("/admin/promos", payload).then((r) => r.data),

  /** PATCH /admin/promos/:id — ADMIN/OPERATIONS only. */
  update: (id: string, payload: Partial<PromoInput>) =>
    apiClient.patch<Promo>(`/admin/promos/${id}`, payload).then((r) => r.data),
};
